'use client'
import { useEffect, useRef } from 'react'
export function OffCanvas({
  show,
  handleClose,
  children,
}: {
  show: boolean
  handleClose: () => void
  children: React.ReactNode
}) {
  const offCanvasRef = useRef(null)

  // prevent body scroll when modal is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [show])

  return (
    <div
      className={`fixed inset-0 bg-black/80 transition-opacity duration-[500ms] ${
        show ? 'opacity-100' : 'opacity-0 pointer-events-none'
      } z-50 overflow-hidden`}
      onClick={handleClose}
    >
      <div
        ref={offCanvasRef}
        className={`fixed bottom-0 w-full md:w-full bg-[#FBFBFB] shadow-lg transition-transform duration-[700ms] transform ${
          show ? 'translate-y-0' : 'translate-y-full'
        } rounded-t-4xl`}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <div className='p-4'>{children}</div>
      </div>
    </div>
  )
}
